import { FC } from 'react';
import { type Quiz } from '@teachur/http-client';
import { AttemptItem } from './AttemptItem';
import { useExamProgress } from '@new/features/courses/hooks/useExamProgress';

interface AttemptsListProps {
  attempts: Quiz[];
}

export const AttemptsList: FC<AttemptsListProps> = ({ attempts }) => {
  const { totalQuestions, attemptProgressItems } = useExamProgress(attempts);

  return (
    <>
      {attemptProgressItems.map(({ attempt, previousCorrectCount, currentCorrectCount }) => (
        <AttemptItem
          key={attempt.id}
          attempt={attempt}
          previousCorrectCount={previousCorrectCount}
          currentCorrectCount={currentCorrectCount}
          totalQuestions={totalQuestions}
        />
      ))}
    </>
  );
};
